export default __webpack_public_path__ + "static/media/risk-roulette-video-edit_V02.02349aa4.mp4";